/**
 * Fetches the Team-member (agent) deactivation message to surface when a
 * deactivated agent attempts to sign in. Hits the public platform endpoint
 * (which resolves the parent org's configured message server-side) and falls
 * back to a sensible default on any failure.
 */
const DEFAULT_AGENT_MESSAGE =
  'Your account is inactive, please speak to your manager to re-activate your account.';

export async function fetchAgentDeactivationMessage(): Promise<string> {
  try {
    const res = await fetch('/api/platform/deactivation-config');
    if (res.ok) {
      const data = await res.json();
      if (data?.agent_message) return data.agent_message as string;
    }
  } catch {
    // Network/parse failure — fall through to the default.
  }
  return DEFAULT_AGENT_MESSAGE;
}
